import React from 'react';
import { Accordion } from './Accordion';
import { OBJECTIONS } from '../lib/data';
export function Objections() {
  return <section className="px-4 py-8" data-id="element-183" data-mp="rkdg4neq8ivi">
      <h2 className="mb-5 text-center font-display text-2xl leading-tight text-white" data-id="element-184" data-mp="rh7slclqxp1w">
        ¿Tienes dudas? Te las resolvemos
      </h2>
      <div className="space-y-3" data-id="element-185" data-mp="hlnvimvg4kbk">
        {OBJECTIONS.map(o => <Accordion key={o.q} emoji="❓" title={o.q} data-id="element-186" data-mp="clrtgt6b72yn">
            <p className="text-[14px] leading-snug text-white/80" data-id="element-187" data-mp="cncoejwjcnx1">{o.a}</p>
          </Accordion>)}
      </div>
    </section>;
}